/* eslint-disable react/no-unknown-property */
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { ImageUrl } from "../../../utils/constants";
import { GetCompletedInitiatives, GetActiveCompletedRecurringInitiatives } from "../../../redux/constants/apiConstants";
import { toast } from "react-toastify";
import { fetchApi } from "../../../utils/methods";
import dayjs from "dayjs";
import SkeletonLoder from "../../common/skeletonLoder";
import { NoData } from "../styles";
import { CommonFilterDropdown } from "../../common/CommonYearFilter/CommonYearFilter";
import { InitiativesWrap, InitiativeCard } from '../../HealthDataManagement/styles';
import { NewDropDownIcon , RecognitionEyeIconNew } from '../../../utils/icons';
import DetailPopup from '../../HealthDataManagement/initiativeParticipantsInfo';
import styled from 'styled-components';
import { InterestCard } from "../../UserProfile/styles"; 

// ---------- Internal styled components ----------
const SectionHeader = styled.h3`
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0 10px;
  color: #184A61;
  font-family: lato;
`;

const MonthHeader = styled.h4`
  font-size: 18px;
  font-weight: bold;
  margin: 15px 0 10px;
  color: #184A61;
  padding: 8px 12px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-family: lato;
  .dropicon {
    transition: transform 0.3s ease;
    transform: ${(props) => (props.isOpen ? "rotate(360deg)" : "rotate(270deg)")};
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;
 
const InitiativeRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin: 0px 0;
`;

const BorderCard = styled.div`
  height: 1px;
  background-color: #e0e0e0;
  margin: 8px 0;
  width: 100%;
`;


class CompletedInitiative extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyId: this.props.companyInfo.id,
      completedInitiatives: [],
      year: new Date().getFullYear(),
      loading: false,
      showDetailPopup: false,
      detailInitiative: null,
      monthFilter: "All Months",
      oneOffInitiatives: [],
      recurringInitiatives: {},
      recurringLoading: false,
      allMonths: ["January", "February", "March", "April", "May", "June", 
        "July", "August", "September", "October", "November", "December"],
      openMonths: [] 
    };

    this.handleEyeIconClick = this.handleEyeIconClick.bind(this);
    this.handleMonthFilterChange = this.handleMonthFilterChange.bind(this);
    this.toggleMonth = this.toggleMonth.bind(this);
  }

  componentDidMount() {
    this.getCompletedInitiatives(this.props.selectedYear);
    this.getRecurringInitiatives(this.props.selectedYear);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedYear !== this.props.selectedYear) {
      this.getCompletedInitiatives(this.props.selectedYear);
      this.getRecurringInitiatives(this.props.selectedYear);
    }
  }

  hideShowPopup = () => {
    this.setState({ showDetailPopup: false, detailInitiative: null });
  }

  showPopup = (data) => {
    this.setState({ showDetailPopup: true, detailInitiative: data });
  }

  handleEyeIconClick(e, initiative) {
    e.stopPropagation();
    e.preventDefault();
    this.showPopup(initiative);
  }

  getCompletedInitiatives = async (year) => {
    this.setState({ loading: true });
    const apiUrl = `${GetCompletedInitiatives}/${this.state.companyId}/${year}`;
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        const initiatives = res?.data || [];
        this.processOneOffInitiatives(initiatives);
      } else {
        toast.error(res.error);
        this.setState({ loading: false });
      }
    } catch (error) {
      this.setState({ loading: false });
    }
  };

  getRecurringInitiatives = async (year) => {
    this.setState({ recurringLoading: true });
    const apiUrl = `${GetActiveCompletedRecurringInitiatives}/${this.state.companyId}/${year}`;
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        const initiativesData = res?.data || [];
        this.processRecurringInitiatives(initiativesData);
      } else {
        toast.error(res.error);
        this.setState({ recurringLoading: false });
      }
    } catch (error) {
      this.setState({ recurringLoading: false });
    }
  };

  processOneOffInitiatives = (initiatives) => {
    const hasInitiativeType = initiatives.length > 0 && 
                              Object.prototype.hasOwnProperty.call(initiatives[0], 'initiative_type');
    
    let oneOffInitiatives = [];
    
    if (hasInitiativeType) {
      oneOffInitiatives = initiatives.filter((i) => i.initiative_type === "one-off");
    } else {
      const recurringNames = [
        "Weight Loss", 
        "Set Monthly Goal", 
        "Financial Wellness Survey", 
        "Preventive Exam"
      ];
      initiatives.forEach((initiative) => {
        if (!recurringNames.includes(initiative.initiative_name)) {
          oneOffInitiatives.push(initiative);
        }
      });
    }
    
    this.setState({ 
      oneOffInitiatives,
      loading: false 
    });
  }

  processRecurringInitiatives = (initiativesData) => {
    const initiativesByMonth = {};
    const availableMonths = new window.Set();
    
    initiativesData.forEach((monthData) => {
      const month = monthData.month_name;
      if (monthData.initiatives && monthData.initiatives.length > 0) {
        initiativesByMonth[month] = monthData.initiatives;
        availableMonths.add(month);
      }
    });
    
    const currentMonth = dayjs().format("MMMM");
    const defaultMonthFilter = availableMonths.has(currentMonth) ? currentMonth : "All Months";
    
    const openMonths = Array.from(availableMonths);
    
    this.setState({ 
      recurringInitiatives: initiativesByMonth,
      monthFilter: defaultMonthFilter,
      openMonths,
      recurringLoading: false 
    });
  }

  handleMonthFilterChange = (selectedMonth) => {
    this.setState({ monthFilter: selectedMonth });
    if (selectedMonth === "All Months") {
      this.setState({ openMonths: this.state.allMonths.filter((month) => this.state.recurringInitiatives[month]) });
    } else {
      this.setState({ openMonths: [selectedMonth] });
    }
  }

  toggleMonth = (month) => {
    this.setState((prevState) => {
      const { openMonths } = prevState;
      if (openMonths.includes(month)) {
        return { openMonths: openMonths.filter((m) => m !== month) };
      } else {
        return { openMonths: [...openMonths, month] };
      }
    });
  }

  chunkArray = (arr, size) => (
    arr.reduce((acc, _, i) => 
      (i % size === 0 ? [...acc, arr.slice(i, i + size)] : acc), [])
  );

  renderOneOffSection = () => {
    const { oneOffInitiatives, loading } = this.state;
    
    if (loading) {
      return (
        <div className="section">
          <SectionHeader>One-Off</SectionHeader>
          <div className='border'/>
          <SkeletonLoder width={"100%"} height={"150px"} />
        </div>
      );
    }
    
    if (!oneOffInitiatives || oneOffInitiatives.length === 0) {
      return null;
    }
    
    const initiativeChunks = this.chunkArray(oneOffInitiatives, 3);
    
    return (
      <div className="section">
        <SectionHeader>One-Off ({oneOffInitiatives.length})</SectionHeader>
        <div className='border'/>
        <div className="details">
          {initiativeChunks.map((chunk, chunkIndex) => (
            <React.Fragment key={`oneoff-chunk-${chunkIndex}`}>
              <InitiativeRow>
                {chunk.map((initiative, idx) => (
                  <div className="initiative-cards" key={`oneoff-${initiative.id || 'noid'}-${chunkIndex}-${idx}`}>
                    <InitiativeCard background={initiative?.color}>
                      <div className="icon">
                        <img 
                          src={`${ImageUrl}/${initiative.initiative_white_icon}`} 
                          alt={initiative.initiative_name}
                          onError={(e) => {
                            e.target.src = `${ImageUrl}/default-initiative.png`;
                          }}
                        />
                      </div>
                      <div className="wrap-content">
                        <div className="title">{initiative.initiative_name}</div>
                        <div className="completed">Completed on {dayjs(initiative.end_date).format("MMMM DD, YYYY")}</div>
                      </div>
                      <div 
                        id="hdm-eyeicon" 
                        className="end-container" 
                        onClick={(e) => this.handleEyeIconClick(e, initiative)}
                        style={{ cursor: 'pointer' }}
                      >
                        {RecognitionEyeIconNew()}
                      </div>
                    </InitiativeCard>
                  </div>
                ))}
              </InitiativeRow>
              {chunkIndex + 1 !== initiativeChunks?.length && <BorderCard />}
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  }

  renderRecurringSection = () => {
    const { recurringInitiatives, monthFilter, recurringLoading, allMonths, openMonths } = this.state;
    
    if (recurringLoading) {
      return (
        <div className="section">
          <SectionHeader>Recurring</SectionHeader>
          <div className='border'/>
          <SkeletonLoder width={"100%"} height={"150px"} />
        </div>
      );
    }
    
    if (!recurringInitiatives || Object.keys(recurringInitiatives).length === 0) {
      return null;
    }
    
    const filterOptions = ["All Months", ...allMonths];
    let monthsToShow = [];
    if (monthFilter === "All Months") {
      monthsToShow = allMonths;
    } else {
      monthsToShow = [monthFilter];
    }
    
    return (
      <div className="section" style={{width:"100%"}}>
        <InitiativesWrap style={{padding:"8px 16px 8px 16px", marginBottom:"20px", justifyContent:"space-between"}}>
          <SectionHeader>
            Recurring ({Object.keys(recurringInitiatives).reduce((acc, month) => 
              acc + recurringInitiatives[month].length, 0)})
          </SectionHeader>
          <CommonFilterDropdown
            options={filterOptions}
            selectedOption={monthFilter}
            setSelectedOption={this.handleMonthFilterChange}
            dropdownWidth="150px"
            dropdownHeight="200px"
            customStyles={{ marginLeft: "15px" }}
          />
        </InitiativesWrap>
        
        <div className="details" style={{width:'100%'}}>
          {monthsToShow.length > 0 ? (
            monthsToShow.map((month) => {
              const monthInitiatives = recurringInitiatives[month] || [];
              const hasInitiatives = monthInitiatives.length > 0;
              const isOpen = openMonths.includes(month);
                
              return (
                <InterestCard key={`month-${month}`} style={{backgroundColor:"#FEFEFE99", marginBottom:'20px'}}>
                  <MonthHeader 
                    isOpen={isOpen} 
                    onClick={() => this.toggleMonth(month)}
                  >
                    {month}
                    <div className="dropicon">
                      <NewDropDownIcon color="#F37A65" />
                    </div>
                  </MonthHeader>
                    
                  {isOpen && hasInitiatives && (
                    <div className="dropdown-wrapper">
                      {this.renderMonthInitiatives(monthInitiatives, month)}
                    </div>
                  )}
                    
                  {isOpen && !hasInitiatives && (
                    <NoData>No Data Found For {month} Month</NoData>
                  )}
                </InterestCard>
              );
            })
          ) : (
            <NoData>No initiatives found for the selected filter</NoData>
          )}
        </div>
      </div>
    );
  }

  renderMonthInitiatives = (initiatives, month) => {
    if (!initiatives || initiatives.length === 0) {
      return <NoData>No Data Found For This Month</NoData>;
    }
    
    const initiativeChunks = this.chunkArray(initiatives, 3);
    
    return (
      <>
        {initiativeChunks.map((chunk, chunkIndex) => (
          <React.Fragment key={`rec-chunk-${month}-${chunkIndex}`}>
            <InitiativeRow>
              {chunk.map((initiative, idx) => (
                <div className="initiative-cards" key={`rec-${initiative.id || 'noid'}-${month}-${chunkIndex}-${idx}`}>
                  <InitiativeCard background={initiative?.color}>
                    <div className="icon">
                      <img 
                        src={`${ImageUrl}/${initiative.initiative_white_icon}`} 
                        alt={initiative.initiative_name}
                        onError={(e) => {
                          e.target.src = `${ImageUrl}/default-initiative.png`;
                        }}
                      />
                    </div>
                    <div className="wrap-content">
                      <div className="title">{initiative.initiative_name}</div>
                    </div>
                    <div 
                      id="hdm-eyeicon" 
                      className="end-container" 
                      onClick={(e) => this.handleEyeIconClick(e, initiative)}
                      style={{ cursor: 'pointer' }}
                    >
                      {RecognitionEyeIconNew()}
                    </div>
                  </InitiativeCard>
                </div>
              ))}
            </InitiativeRow>
            {chunkIndex + 1 !== initiativeChunks?.length && <BorderCard />}
          </React.Fragment>
        ))}
      </>
    );
  }

  render() {
    const { loading, recurringLoading, showDetailPopup, detailInitiative, oneOffInitiatives, recurringInitiatives } = this.state;

    if (loading && recurringLoading) {
      return (
        <div style={{ width: '385px' }}> 
          <SkeletonLoder width={"1248px"} height={"500px"} />
        </div>
      );
    }

    return (
      <>
        <InitiativesWrap>
          {this.renderOneOffSection()}
        </InitiativesWrap>
        {this.renderRecurringSection()}
          
        {(!oneOffInitiatives || oneOffInitiatives.length === 0) && 
           (!recurringInitiatives || Object.keys(recurringInitiatives).length === 0) && 
           <NoData>No Data Found!</NoData>}
        
        
        {showDetailPopup && (
          <DetailPopup 
            showModal={showDetailPopup} 
            detailInitiative={detailInitiative} 
            onClose={this.hideShowPopup} 
            companyId={this.props.companyInfo.id}
          />
        )}
      </>
    );
  }
}

CompletedInitiative.propTypes = {
  history: PropTypes.object,
  companyId: PropTypes.any,
  companyInfo: PropTypes.any,
  isHealthDash: PropTypes.bool,
  isLibrary: PropTypes.bool,
  setPage: PropTypes.func,
  role: PropTypes.string,
  selectedYearInfo: PropTypes.number,
  selectedYear: PropTypes.number
};

export default connect(
  null,
  null
)(CompletedInitiative);